import React from 'react';
import { useRemoteData } from '../../../model/data';
import { getContract } from '../../../model/contract';
import { t } from '../../../locales/translate';
import { NavLink } from 'react-router-dom';
import { contractPath } from '../../../routes';
import { isAdmin, useSelectedMembership } from '../../../model/membership';

export function ContractName({ id }: { id: string }): JSX.Element {
  const membership = useSelectedMembership();
  const [contract, loading, error] = useRemoteData(
    () => getContract(id),
    (db) => db.table('contracts').find(id),
    [id]
  );

  if (loading) {
    return <span>{t.actions.loading(t.model.contract._name)}</span>;
  } else if (error?.['response']?.['status'] === 403) {
    return <span>{t.model.contract.notAuthorized}</span>;
  } else if (error || !contract) {
    return <span>{t.errors.errorLoadingItem(t.model.contract._name)}</span>;
  }

  // The detail page would be visible, but we do not want to actively link to that contract page unless the user is admin.
  if (isAdmin(membership)) {
    return (
      <NavLink className="order-items__button-link button button--link" to={contractPath(contract.id)}>
        <span>{contract.name}</span>
      </NavLink>
    );
  }

  return <span>{contract.name}</span>;
}
